<script setup>
import Width from "@/pages/Index/Width.vue";
import MoreButton from "@/pages/Index/components/MoreButton.vue";
import Title from "@/components/Title/Title.vue";
import SvgIcon from "@/components/SvgIcon/SvgIcon.vue";
import {computed, onMounted, onUnmounted, reactive} from "vue";
import Rolling from "@/pages/Index/components/Rolling.vue";
import {useRouter} from "vue-router";
import {useStore} from "vuex";

const router = useRouter()
const store = useStore()

const props = defineProps({
	honors: {
		type: Array,
		default: () => []
	},
	companyInfo: {
		type: Object,
		default: () => ({})
	}
})

const honorImgs = computed(() => props.honors.map(item => item.picture))

const companyInfo = computed(() => props.companyInfo)

const currentLang = computed(() => store.getters.currentLanguage)

const state = reactive({
	width: '285px',
	height: '184px'
});

const handleResize = () => {
	const windowWidth = window.innerWidth;
	if (windowWidth <= 535) {
		state.width = '142px';
		state.height = '92px';
	} else {
		state.width = '285px';
		state.height = '184px';
	}
};

const handleToPage = () => {
	router.push('/manufacture')
}

onMounted(() => {
	handleResize(); // 初始化时调用一次
	window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
	window.removeEventListener('resize', handleResize);
});
</script>

<template>
	<div class="honor">
		<Width>
			<div class="honor__header">
				<Title
					:title="$t('section.honor.title')"
					mode="dark"
					position="left"
				/>
				
				<MoreButton
					class="more-button-pc"
					:btn-text="$t('section.honor.more')"
					@click="handleToPage"
				/>
				
				<div class="honor__content__icon honor__content__icon--mobile">
					<SvgIcon name="marks" class-name="mark-icon" />
				</div>
			</div>
			
			<div class="honor__content">
				<div class="honor__content__icon honor__content__icon--pc">
					<SvgIcon name="marks" class-name="mark-icon" />
				</div>
				<div class="honor__content__title">
					{{ companyInfo?.[`enterprise_honor_title_${currentLang}`] }}
				</div>
				
				<div class="honor__content__text">
					<pre style="width: 100%;white-space: pre-line;margin-bottom: 0;font-family: inherit;">
						{{ companyInfo?.[`enterprise_honor_content_${currentLang}`] }}
					</pre>
					
				</div>
			</div>
			
			<div class="honor__honor-list">
				<Rolling
					:list="honorImgs"
					:custom-style="{
						width: state.width,
						height: state.height
					}"
				/>
			</div>
			
			<div class="more-button-mobile">
				<MoreButton
					:btn-text="$t('section.honor.more')"
					@click="handleToPage"
				/>
			</div>
		</Width>
	</div>
</template>

<style scoped lang="less">
.honor {
	background-image: url("~@/assets/images/bg/honor-bg.png");
	background-size: cover;
	background-repeat: no-repeat;
	padding: 70px 0 126px 0;
	
	.more-button-mobile {
		display: none;
	}
	
	&__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: relative;
	}
	
	&__content {
		position: relative;
		padding-top: 64px;
		
		&__icon {
			position: absolute;
			
			&--pc {
				top: 24px;
				right: 0;
			}
			
			&--mobile {
				display: none;
				top: 0;
				right: 0;
			}
			
			.mark-icon {
				width: 191px;
				height: 155px;
			}
		}
		
		&__title {
			font-size: 24px;
			font-weight: bold;
			color: @primary-color;
		}
		
		&__text {
			margin-top: 30px;
			font-size: 18px;
			line-height: 28px;
			color: #303133;
			
			.line-1 {
				//margin-bottom: 20px;
			}
		}
	}
	
	&__honor-list {
		margin-top: 92px;
	}
}

@media only screen and (max-width: 768px) {
	.honor {
		padding: 30px 0;

		.more-button-pc {
			display: none;
		}
		
		.more-button-mobile {
			margin-top: 20px;
			display: flex;
			justify-content: center;
		}
		
		&__content {
			padding-top: 20px;
			
			&__icon {
				
				&--pc {
					display: none;
				}
				
				&--mobile {
					display: block;
				}
				
				.mark-icon {
					width: 80px;
					height: 65px;
				}
			}
			
			&__title {
				font-size: 18px;
				font-weight: bold;
				color: @primary-color;
			}
			
			&__text {
				margin-top: 12px;
				font-size: 16px;
				line-height: 28px;
				color: #303133;
				
				.line-1 {
					//margin-bottom: 10px;
				}
			}
		}
		
		&__honor-list {
			margin-top: 30px;
		}
	}
}
</style>